import { Outlet } from "react-router-dom";

const ReportMainPage = () => {
    return <Outlet />;
}

export default ReportMainPage;